var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8188 18.0595C11.8188 17.8676 11.8567 17.6775 11.9305 17.5005C12.0045 17.3232 12.1126 17.1625 12.2489 17.0275C12.3852 16.8924 12.547 16.7856 12.7247 16.7134C12.9026 16.6411 13.0928 16.6048 13.2848 16.6065C13.5679 16.6117 13.8432 16.7 14.0763 16.8608C14.3093 17.0215 14.49 17.2475 14.5953 17.5102C14.7008 17.773 14.7262 18.061 14.6689 18.3383C14.6114 18.6155 14.4735 18.8696 14.2724 19.069C14.0713 19.2683 13.816 19.4039 13.5383 19.4589C13.2605 19.5139 12.9727 19.4857 12.7109 19.3779C12.4489 19.2702 12.2248 19.0877 12.0661 18.8532C11.9075 18.6187 11.8214 18.3427 11.8188 18.0595ZM12.2857 14.5178L12.1041 7.74596C12.0869 7.58318 12.1041 7.41859 12.1547 7.26289C12.2052 7.10717 12.2878 6.96381 12.3973 6.84212C12.5068 6.72042 12.6407 6.62313 12.7901 6.55651C12.9397 6.48991 13.1016 6.45547 13.2652 6.45547C13.4289 6.45547 13.5908 6.48991 13.7404 6.55651C13.8899 6.62313 14.0237 6.72042 14.1332 6.84212C14.2427 6.96381 14.3254 7.10717 14.3758 7.26289C14.4264 7.41859 14.4437 7.58318 14.4264 7.74596L14.2578 14.5178C14.2578 14.7792 14.154 15.0301 13.969 15.215C13.7841 15.3999 13.5332 15.5038 13.2718 15.5038C13.0103 15.5038 12.7595 15.3999 12.5747 15.215C12.3898 15.0301 12.2857 14.7792 12.2857 14.5178Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2708 25C19.8981 25 25.2708 19.6274 25.2708 13C25.2708 6.37259 19.8981 1 13.2708 1C6.64334 1 1.27075 6.37259 1.27075 13C1.27075 19.6274 6.64334 25 13.2708 25Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.3a21923194069b8c75d6476bc5cc683c.svg";
export { ForwardRef as ReactComponent };